import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './TopBarWrapper.module.css';

type TopBarWrapperProps = HTMLAttributes<HTMLDivElement> & {
  sticky?: boolean;
};

const TopBarWrapper: FC<TopBarWrapperProps> = ({ className, sticky, ...props }) => (
  <div className={clsx(s.wrapper, sticky && s.sticky, className)} {...props} />
);

export { TopBarWrapper };
